<template>
  <div>
    <div
        id="NetworkMarket"
        :style="{ backgroundImage: 'url(' + backImg + ')' }"
    >
      <div class="centent_box">
        <div class="center_box">
          <div class="prev_btn" @mouseenter="prevEnter" @mouseleave="prevLeave">
            <img
                :src="prev_image"
                class="img_cover"
                alt=""
                v-if="trueIndex > 0"
            />
          </div>
          <div class="content_box">
            <swiper
                :options="swiperOptionNetwork"
                class="NetworkSwiper"
                ref="mySwiper"
            >
              <swiper-slide class="item_box">
                <div class="title">国内营销网络</div>
                <div class="info">天亿销售网络总有一个在您身边</div>
                <div
                    class="char"
                    ref="chart"
                    id="charts"
                    style="width: 100%; height: 700px; z-index: 0"
                ></div>
              </swiper-slide>
              <swiper-slide class="item_box">
                <div class="title">国际营销网络</div>
                <div class="info">天亿销售网络总有一个在您身边</div>
                <!-- <img
                    class="img_cover word_img"
                    style="width: 93%;"
                    src="../../assets/indexImg/network_word.png"
                    alt=""
                /> -->
                <img
                    class="img_cover word_img"
                    style="width: 93%;"
                    src="../../assets/indexImg/tu.png"
                    alt=""
                />
              </swiper-slide>
            </swiper>
          </div>
          <div class="next_btn" @mouseenter="nextEnter" @mouseleave="nextLeave">
            <img
                :src="next_image"
                class="img_cover"
                alt=""
                v-if="trueIndex < 1"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="font-size: 16px;color: #FFFFFF;position: absolute;bottom: 40px;z-index: 1; left: 50%;transform: translateX(-50%);">随时为用户提供强大完善的服务保障，请联系区域负责经理进行咨询或拨打营销热线：管道400-002-0026 地板 400-666-2151</div>
  </div>
</template>

<script>
import {getMarketing} from "../../http/api";
import "./map";

export default {
  name: "",
  props: {},
  components: {},
  data() {
    var that = this;
    return {
      backImg: "",
      trueIndex: 0,
      swiperOptionNetwork: {
        slidesPerView: 1,
        navigation: {
          nextEl: ".next_btn",
          prevEl: ".prev_btn",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.trueIndex = this.realIndex;
          },
        },
      },

      dataArr: [],
      prev_image: require("../../assets/indexImg/transparent_prev_img.png"),
      next_image: require("../../assets/indexImg/transparent_next_img.png"),
      textLength: 0,
      option: {
        dataRange: {
          show: false,
          x: "center",
          y: "bottom",
          splitList: [{start: 0, end: 5, color: "#2e9da4"}],
        },
        tooltip: {
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#ffffff",
            },
          },
          position: function (point, params, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            var x = point[0];
            var y = point[1];
            if (y > 222) {
              var posX = x - 300; // x坐标位置
              var posY = y - 200; // y坐标位置
              let bottomhied = document.getElementById("bottomshow");
              bottomhied.style.display = "none";
              let centerApp = document.getElementById("centerApp");
              centerApp.style.bottom = "0";
            } else {
              var posX = x - 300; // x坐标位置
              var posY = y + 120; // y坐标位置
              let tophied = document.getElementById("topshow");
              tophied.style.display = "none";
              let centerApp = document.getElementById("centerApp");
              centerApp.style.top = "0";
            }
            return [posX, posY];
          },
          // backgroundColor: "rgba(15, 255, 255, 0.2)",
          backgroundColor: "rgba(255,255,255,0)",
          formatter: function (data) {
            var province = $.trim(data.name);
            var flag = false;
            var vhtml = "";
            // 管道：四川分公司 陈超 13890922359  宜宾分公司：陈春容 15808455682
            // 地板：成都：焦勇  136 0806 5139    宜宾  地板：成都：焦勇  136 0806 5139       
            var textnum = 0;
            console.log(province)
            that.dataArr.map((item) => {
              if (item.name === province ) {
                if(item.conduit !='' || item.floor!=''){
                  flag = true;
                  vhtml = `
                <div style="position:relative;height:126px;width:498px;background:transparent;">
                  <div id="bottomshow" style="width:186px ;position: absolute;top:0;height:1px;background:rgb(15,255,255);transform: rotate(-30deg) translateX(50%) translateY(50px);transform-origin:left top;"></div>
                    <div id="centerApp" style="min-width:248px;min-height:126px;max-width:498px;position: absolute;border:1px solid white;background-color:rgba(15, 255, 255, 0.4);">
                <div class="content_title" style="font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  line-height: 20px;
                  color: #FFFFFF;width:100%;text-align:center;padding:10px 0;">${province} 负责人</div>
                <div style='padding-bottom:10px;font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 28px;
                  color: #FFFFFF;margin: 0 10px; white-space:pre-wrap;'>${
                      // item.conduit !== "" ? item.conduit : "管道  暂无"
                      item.conduit !== "" ? item.conduit : ""
                  }</div>
                    <div style='font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 28px;
                  color: #FFFFFF;margin: 0 10px 10px 10px; white-space:pre-wrap;'>${
                      // item.floor !== "" ? item.floor : "地板  暂无"
                      item.floor !== "" ? item.floor : ""
                  }</div>
                  </div>
                  <div id="topshow" style="width:186px;height:1px;background:rgb(15,255,255);transform: rotate(30deg) translateX(50%) translateY(-50px);position: absolute;bottom:0;transform-origin:left top;"></div>
                </div>
                `;
                }
              }
            });

            return flag
                ? vhtml
                : `
              <div style="min-width:248px;height:126px;border:1px solid white;background-color:rgba(15, 255, 255, 0.4);">
              <div id="bottomshow" style="width:186px;height:1px;background:rgb(15,255,255);transform: rotate(-30deg) translateX(65%) translateY(10px);"></div>
                <div class="content_title" style="font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    line-height: 20px;
                    color: #FFFFFF;width:100%;text-align:center;padding:10px 0;">${province} 负责人</div>
                <div style='padding-bottom:10px;font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 28px;
                    color: #FFFFFF;margin-left:10px;'>管道 暂无</div>
                    <div  style='font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 28px;
                    color: #FFFFFF;margin-left:10px;'>地板 暂无</div>
                    <div id="topshow"  style="width:186px;height:1px;background:rgb(15,255,255);transform: rotate(30deg) translateX(65%) translateY(10px);"></div>
                    </div>
                   `;
          },
        },
        series: [
          {
            zoom: 2.2,
            name: "动图",
            type: "map",
            // type: "effectScatter",
            mapType: "china",
            roam: true,
            itemStyle: {
              normal: {
                borderWidth: 1,
                borderColor: "#ffffff",
                color: "#435a65",
                areaColor: "#435a65",
                label: {
                  show: true,
                  textStyle: {
                    color: "transparent",
                  },
                },
              },
              // rippleEffect: {
              //   period: 3, //波纹秒数
              //   brushType: "fill", //stroke(涟漪)和fill(扩散)，两种效果
              //   scale: 10, //波纹范围
              // },
              emphasis: {
                color: "#2e9ea5",
                borderWidth: 1,
                borderColor: "#ffffff",
                areaColor: "#2e9ea5",
                label: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
            },

            data: [],
          },
        ],
        animation: true,
      },
      // mycharts: "",
    };
  },
  methods: {
    // select_province(province_name) {
    //   console.log(province_name);
    // },
    prevLeave() {
      this.prev_image = require("../../assets/indexImg/transparent_prev_img.png");
    },
    prevEnter() {
      this.prev_image = require("../../assets/indexImg/blue_prev_img.png");
    },
    nextLeave() {
      this.next_image = require("../../assets/indexImg/transparent_next_img.png");
    },
    nextEnter() {
      this.next_image = require("../../assets/indexImg/blue_next_img.png");
    },
  },

  mounted() {
    if (this.baclgroundInfo.length === 0) {
      setTimeout(() => {
        var obj = this.baclgroundInfo;
        this.backImg = obj[4].image;
      }, 500);
    } else {
      var obj = this.baclgroundInfo;
      this.backImg = obj[4].image;
    }
    getMarketing().then((res) => {
      var arr = [];
      for (var key in res.data) {
        arr.push(res.data[key]);
      }
      this.dataArr = arr;
      console.log(
          this.dataArr[1].conduit.length + this.dataArr[1].floor.length
      );
    });
    this.mycharts = echarts.init(document.getElementById("charts"));
    // console.log(this.mycharts);
    this.mycharts.setOption(this.option);
  },
  computed: {
    baclgroundInfo() {
      return this.$store.state.baclgroundInfo;
    },
  },
  watch: {},
};
</script>

<style scoped lang='scss'>
#NetworkMarket {
  width: 100%;
  height: 100vh;
  min-width: 1500px;
  background: #1a1a1a;
  background-size: cover;
  position: relative;
  cursor: pointer !important;
  // transform: ;

  .centent_box {
    width: 100%;
    // height: 827px;
    height: 82.7vh;
    position: absolute;
    // top: 120px;
    top: 12vh;
    display: flex;
    justify-content: center;

    .center_box {
      // width: 1684px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .content_box {
        // width: 1154px;
        // width: 1273px;
        width: 100%;
        height: 100%;

        .NetworkSwiper {
          width: 100%;
          height: 100%;

          .item_box {
            width: 100%;
            height: 100%;
            position: relative;
            // .char{
            //   position: absolute;
            //   top: 60px;
            //   z-index: 0 !important;
            // }
            #charts {
              position: absolute;
              top: 50px;
              z-index: 0 !important;
              cursor: pointer !important;

              div {
                cursor: pointer !important;
              }
            }

            .title {
              // font-size: 18px;
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ffffff;
              letter-spacing: 10px;
              text-align: center;
              z-index: 9 !important;
              position: absolute;
              width: 100%;
              text-align: center;
              top: 0;
            }

            .word_img {
              display: block;
              margin: 0 auto;
            }

            .info {
              // font-size: 14px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              text-align: center;
              color: #ffffff;
              // margin: 10px 0 19px 0;
              margin: 2vh 0 1.9vh 0;
              z-index: 9 !important;
              position: absolute;
              width: 100%;
              // top: 20px;
              top: 2vh;
              text-align: center;
            }
          }
        }
      }

      .prev_btn {
        width: 92px;
        height: 92px;
        position: fixed;
        left: 118px;
        z-index: 99;
      }

      .prev_btn:focus,
      .next_btn:focus {
        outline: none;
      }

      .next_btn {
        position: fixed;
        width: 92px;
        height: 92px;
        right: 118px;
        z-index: 99;
      }
    }
  }
}
</style>